import axiosInstanceNew from "lib/axiosinstanceNew";

const Finanacemanagement = class {
  constructor() {
    this.baseUrl = "invoice/";
    this.staticData = [
      {
        id: 1,
        invoice_number: "INV-2024-001",
        client_id: 101,
        client: {
          first_name: "Rahul",
          last_name: "Sharma",
        },
        cycleData: [{ cycle_number: "Cycle 1" }],
        total_amount: 15000,
        updatedAt: "2024-11-05T10:30:00Z",
        grossMargin: 2500,
        due_amount: 5000,
        class: { name: "Mathematics Advanced - Grade 10" },
        status: "Unpaid",
      },
      {
        id: 2,
        invoice_number: "INV-2024-002",
        client_id: 102,
        client: {
          first_name: "Priya",
          last_name: "Patel",
        },
        cycleData: [{ cycle_number: "Cycle 2" }],
        total_amount: 22000,
        updatedAt: "2024-11-03T14:20:00Z",
        grossMargin: 3500,
        due_amount: 8000,
        class: { name: "Science Comprehensive - Grade 9" },
        status: "Pending",
      },
      {
        id: 3,
        invoice_number: "INV-2024-003",
        client_id: 103,
        client: {
          first_name: "Amit",
          last_name: "Verma",
        },
        cycleData: [{ cycle_number: "Cycle 1" }],
        total_amount: 12000,
        updatedAt: "2024-10-28T09:15:00Z",
        grossMargin: 1800,
        due_amount: 0,
        class: { name: "English Literature - Grade 8" },
        status: "Completed",
      },
      {
        id: 4,
        invoice_number: "INV-2024-004",
        client_id: 104,
        client: {
          first_name: "Sneha",
          last_name: "Gupta",
        },
        cycleData: [{ cycle_number: "Cycle 3" }],
        total_amount: 18000,
        updatedAt: "2024-10-30T16:45:00Z",
        grossMargin: 2800,
        due_amount: 3000,
        class: { name: "Social Studies - Grade 7" },
        status: "Unpaid",
      },
      {
        id: 5,
        invoice_number: "INV-2024-005",
        client_id: 105,
        client: {
          first_name: "Vikram",
          last_name: "Singh",
        },
        cycleData: [{ cycle_number: "Cycle 2" }],
        total_amount: 16000,
        updatedAt: "2024-11-01T11:30:00Z",
        grossMargin: 2400,
        due_amount: 16000,
        class: { name: "Hindi & Sanskrit - Grade 6" },
        status: "Void",
      },
      {
        id: 6,
        invoice_number: "INV-2024-006",
        client_id: 106,
        client: {
          first_name: "Deepak",
          last_name: "Kumar",
        },
        cycleData: [{ cycle_number: "Cycle 1" }],
        total_amount: 14000,
        updatedAt: "2024-10-25T13:20:00Z",
        grossMargin: 2100,
        due_amount: 0,
        class: { name: "Computer Science - Grade 9" },
        status: "Completed",
      },
      {
        id: 7,
        invoice_number: "INV-2024-007",
        client_id: 107,
        client: {
          first_name: "Kavita",
          last_name: "Singh",
        },
        cycleData: [{ cycle_number: "Cycle 4" }],
        total_amount: 25000,
        updatedAt: "2024-11-07T08:45:00Z",
        grossMargin: 4000,
        due_amount: 10000,
        class: { name: "Physics Advanced - Grade 11" },
        status: "Pending",
      },
    ];
    this.staticDataTutor = [
      {
        id: 1,
        tutor_id: 201,
        tutorInfo: {
          first_name: "Rajesh",
          last_name: "Kumar",
          username: "+91-9876543210",
        },
        classInfo: {
          name: "Mathematics Advanced - Grade 10",
        },
        total_amount: 12000,
        status: "Unpaid",
        remark: "Regular monthly payment",
        payment_due_date: "2024-11-15",
        cycle_completion_date: "2024-11-10",
      },
      {
        id: 2,
        tutor_id: 202,
        tutorInfo: {
          first_name: "Priya",
          last_name: "Sharma",
          username: "+91-9876543211",
        },
        classInfo: {
          name: "Science Comprehensive - Grade 9",
        },
        total_amount: 15000,
        status: "Pending",
        remark: "Includes bonus for extra classes",
        payment_due_date: "2024-11-12",
        cycle_completion_date: "2024-11-08",
      },
      {
        id: 3,
        tutor_id: 203,
        tutorInfo: {
          first_name: "Amit",
          last_name: "Verma",
          username: "+91-9876543212",
        },
        classInfo: {
          name: "English Literature - Grade 8",
        },
        total_amount: 10000,
        status: "Completed",
        remark: "Payment processed successfully",
        payment_due_date: "2024-10-30",
        cycle_completion_date: "2024-10-25",
      },
      {
        id: 4,
        tutor_id: 204,
        tutorInfo: {
          first_name: "Sneha",
          last_name: "Gupta",
          username: "+91-9876543213",
        },
        classInfo: {
          name: "Social Studies - Grade 7",
        },
        total_amount: 13000,
        status: "Unpaid",
        remark: "Deduction for absent class",
        payment_due_date: "2024-11-18",
        cycle_completion_date: "2024-11-12",
      },
      {
        id: 5,
        tutor_id: 205,
        tutorInfo: {
          first_name: "Vikram",
          last_name: "Singh",
          username: "+91-9876543214",
        },
        classInfo: {
          name: "Hindi & Sanskrit - Grade 6",
        },
        total_amount: 11000,
        status: "Void",
        remark: "Cancelled due to student withdrawal",
        payment_due_date: "2024-11-05",
        cycle_completion_date: "2024-11-01",
      },
      {
        id: 6,
        tutor_id: 206,
        tutorInfo: {
          first_name: "Deepak",
          last_name: "Joshi",
          username: "+91-9876543215",
        },
        classInfo: {
          name: "Computer Science - Grade 9",
        },
        total_amount: 14000,
        status: "Pending",
        remark: "Awaiting approval from admin",
        payment_due_date: "2024-11-20",
        cycle_completion_date: "2024-11-15",
      },
      {
        id: 7,
        tutor_id: 207,
        tutorInfo: {
          first_name: "Kavita",
          last_name: "Patel",
          username: "+91-9876543216",
        },
        classInfo: {
          name: "Physics Advanced - Grade 11",
        },
        total_amount: 16000,
        status: "Completed",
        remark: "Bonus included for excellent performance",
        payment_due_date: "2024-10-28",
        cycle_completion_date: "2024-10-22",
      },
    ];
  }
  invoice;
  // get all invoice
  async listofInvoice(query = []) {
    // Return static invoice data
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: this.staticData,
            meta: {
              current_page: 1,
              per_page: 20,
              total_page: Math.ceil(this.staticData.length / 20),
              total: this.staticData.length,
            },
          },
        });
      }, 500);
    });
  }
  async listofInvoicestatus(status, query = []) {
    // Return static invoice data filtered by status
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        if (status && status !== "All") {
          filteredData = this.staticData.filter(
            (item) => item.status === status
          );
        }
        resolve({
          data: {
            data: filteredData,
            meta: {
              current_page: 1,
              per_page: 20,
              total_page: Math.ceil(filteredData.length / 20),
              total: filteredData.length,
            },
          },
        });
      }, 500);
    });
  }
  async listOfInvoiceDate(start_date, end_date, status_filter) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      let filteredData = this.staticData;

      // Filter by date range if provided
      if (start_date && end_date) {
        const startDate = new Date(start_date);
        const endDate = new Date(end_date);

        filteredData = this.staticData.filter((item) => {
          const itemDate = new Date(item.updatedAt);
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      // Filter by status if provided
      if (status_filter && status_filter !== "All") {
        filteredData = filteredData.filter(
          (item) => item.status === status_filter
        );
      }

      return {
        data: {
          data: filteredData,
          meta: {
            total: filteredData.length,
            per_page: 10,
            current_page: 1,
            last_page: Math.ceil(filteredData.length / 10),
          },
        },
      };
    } catch (error) {
      console.error("Error fetching invoice data by date:", error);
      throw error;
    }
  }
  // add invoice
  async addInvoice(data) {
    return await axiosInstanceNew.post(`invoice`, data);
  }
  // delete invoice
  async deleteInvoice(id) {
    return await axiosInstanceNew.delete(`invoice/${id}`);
  }
  // get invoice list of paticular client
  async invoicelistbyid(id) {
    return await axiosInstanceNew.get(`invoice?client_id=${id}`);
  }
  // marked as paid
  async markedinvoicepaid(data = []) {
    return await axiosInstanceNew.post(`payments`, data);
  }
  // edit invoice
  async EditInvoice(id, data = []) {
    return await axiosInstanceNew.put(`invoice/${id}`, data);
  }
  // get tutor salary list
  async GetTutorSalaryListAll() {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: this.staticDataTutor,
      };
    } catch (error) {
      console.error("Error fetching tutor salary data:", error);
      throw error;
    }
  }
  async GetTutorSalaryList(status) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      let filteredData = this.staticDataTutor;

      // Filter by status if provided
      if (status) {
        filteredData = this.staticDataTutor.filter(
          (item) => item.status === status
        );
      }

      return {
        data: filteredData,
      };
    } catch (error) {
      console.error("Error fetching tutor salary data by status:", error);
      throw error;
    }
  }
  async listOfInvoiceDatee(from, to, status) {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      let filteredData = this.staticDataTutor;

      // Filter by date range if provided
      if (from && to) {
        const startDate = new Date(from);
        const endDate = new Date(to);

        filteredData = this.staticDataTutor.filter((item) => {
          const itemDate = new Date(item.cycle_completion_date);
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      // Filter by status if provided
      if (status) {
        filteredData = filteredData.filter((item) => item.status === status);
      }

      return {
        data: filteredData,
      };
    } catch (error) {
      console.error("Error fetching tutor salary data by date:", error);
      throw error;
    }
  }
  // add draft tutor
  async AddDraftTutor(data = []) {
    return await axiosInstanceNew.post(`salary`, data);
  }
  // edit draft tutor
  async EditDraftTutor(id, data = []) {
    return await axiosInstanceNew.put(`salary/${id}`, data);
  }
  // delete draft tutor
  async DeleteDraftTutor(id) {
    return await axiosInstanceNew.delete(`salary/${id}`);
  }
  // get drafttutor deatail
  async DraftTutorDeatail(id, date, status) {
    // Build the query string dynamically
    const params = new URLSearchParams();

    if (id) params.append("tutor_id", id);
    if (date) params.append("date", date);
    if (status) params.append("pay_status", status);
    params.append("page", "tutor_salary");
    // Make the API call with the constructed query string
    return await axiosInstanceNew.get(`salary`, { params });
  }
  async getsummary() {
    return await axiosInstanceNew.get(`invoice/summary/invoice_summary `);
  }
};
export default new Finanacemanagement();
